<template>
    <div>
        <div class="relativeposition">
            <img :src="vcfLogo" class="logo" />
            <img :src="topBannerImage" class="topbanner" />
        </div>
        <!-- <Header :label="$t('vfair.header')" overlap="small" /> -->
        <div class="relativeposition">
            <div class="countdownwrapper">
                <countdown :caption="'Next Fair in'" :timestamp="nextVFairTimeStamp"></countdown>
            </div>
            <MainLayout hide-on-mobile="left right">
                <div slot="top">
                    <h4 class="pt-5">{{ $t('vfair.signUpToday') }}</h4>
                    <p class="mb-4">{{ $t('vfair.vfairsInfo') }}</p>
                </div>
                <VFairList slot="top" with-layout-toggle :data="data()" :is-loading="loading()" />

                <div slot="top" class="pt-5">
                    <h4>{{ $t('vfair.recruitingOrgs') }}</h4>
                </div>

                <Paper slot="top">
                    <CompanyList
                        :data="organizations"
                        :label="$t('vfair.preRegistered')"
                        :isLoading="companiesLoading"
                    ></CompanyList>
                </Paper>

                <div slot="top" class="pt-5">
                    <h4>{{ $t('vfair.prepareForTheFair') }}</h4>
                    <Paper class="p-3">
                        <div class="card-deck">
                            <LinkCard
                                :img="masterClass"
                                :title="$t('vfair.links.masterclasses.header')"
                                :body="$t('vfair.links.masterclasses.description')"
                                :buttonCaption="$t('vfair.links.masterclasses.buttonCaption')"
                                routerTarget="/resources"
                            ></LinkCard>
                            <LinkCard
                                :img="cv"
                                :title="$t('vfair.links.cv.header')"
                                :body="$t('vfair.links.cv.description')"
                                :buttonCaption="$t('vfair.links.cv.buttonCaption')"
                                :blankTarget="cvTemplateLink"
                            ></LinkCard>
                            <LinkCard
                                :img="elevatorPitch"
                                :title="$t('vfair.links.elevatorPitch.header')"
                                :body="$t('vfair.links.elevatorPitch.description')"
                                :buttonCaption="$t('vfair.links.elevatorPitch.buttonCaption')"
                                blankTarget="https://forms.gle/MD6yp2C6T1o3Yb7B6"
                            ></LinkCard>
                        </div>
                    </Paper>
                </div>
            </MainLayout>
            <Footer></Footer>
        </div>
    </div>
</template>

<script>
// Project components
import MainLayout from '~/components/layouts/mainlayout/MainLayout';
import VFairList from './components/VFairList';
import Countdown from './components/Countdown';
import TopBannerImage from '~/assets/img/vcf/HeroBanner.png';
import VCFLogo from '~/assets/img/vcf/VCFLogo.png';
import CV from '~/assets/img/vcf/CV.jpg';
import MasterClass from '~/assets/img/vcf/Masterclass.jpg';
import ElevatorPitch from '~/assets/img/vcf/ElevatorPitch.jpg';
import LinkCard from './components/LinkCard';
import Paper from '~/components/builders/Paper';
import Footer from '../components/Footer';
import CompanyList from '~/shared/CompanyList';

import { HIGHERED_CV_TEMPLATE } from '~/services/ResourceService';

export default {
    name: 'FindVFairs',
    components: {
        MainLayout,
        VFairList,
        Countdown,
        LinkCard,
        Paper,
        Footer,
        CompanyList,
    },
    computed: {
        vfairs() {
            return this.$interfaces.vfair.get({
                reactive: true,
            });
        },
        nextVFairTimeStamp() {
            const data = this.data();
            if (data.length > 0) {
                return new Date(data[0].start);
            } else {
                return new Date(Date.now());
            }
        },
    },
    data() {
        return {
            topBannerImage: TopBannerImage,
            vcfLogo: VCFLogo,
            cv: CV,
            elevatorPitch: ElevatorPitch,
            masterClass: MasterClass,
            cvTemplateLink: HIGHERED_CV_TEMPLATE,
            organizations: [],
            companiesLoading: false,
        };
    },
    methods: {
        data() {
            return this.vfairs.data
                .filter(item => {
                    let check = item.start;
                    if (!item.oneDayEvent) {
                        check = item.end;
                    }
                    let now = new Date();
                    let then = new Date(check);
                    then.setDate(then.getDate() + 1);
                    return now < then && item.active;
                })
                .sort((a, b) => (a.start > b.start ? 1 : -1));
        },
        loading() {
            return this.vfairs.loading;
        },
    },
    mounted() {
        this.$interfaces.vfairs.organizations.get().then(orgs => {
            this.organizations = [];
            orgs.data.forEach(org => {
                if (this.organizations.find(o => o.id == org.organizationId) === undefined) {
                    this.organizations.push({
                        id: org.organizationId,
                        logo: org.logo,
                        name: org.title,
                    });
                }
            });

            this.companiesLoading = false;
        });
    },
};
</script>

<style scoped>
.relativeposition {
    position: relative;
}
.topbanner {
    width: 100%;
}
.logo {
    width: 44%;
    position: absolute;
    left: 28%;
    top: 35%;
    z-index: 1;
}

@media only screen and (max-width: 600px) {
    .logo {
        width: 74%;
        left: 13%;
        top: 25%;
    }
}
.countdownwrapper {
    position: absolute;
    transform: translate(-50%, -100%);
    left: 50%;
}
</style>
